import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-user-password-form',
  templateUrl: './user-password-form.component.html',
  styleUrl: './user-password-form.component.scss',
})
export class UserPasswordFormComponent {
  form!: FormGroup;
  isEditing = false;
  saving = false;

  constructor(private fb: FormBuilder, protected userService: UserService) {
    this.form = this.fb.group({
      old_password: ['', [Validators.required]],
      // 6 mirrors MIN_PASSWORD_LENGTH in al-user-management
      // (app/password_policy.py). The server additionally refuses the obvious
      // ones and anything containing the account's own email or name.
      new_password: ['', [Validators.required, Validators.minLength(6)]],
      confirm_new_password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit() {
    this.userService.me$.subscribe((org) => {
      if (org) {
        this.form.patchValue(org);
      }
    });
  }

  async onSubmit() {
    if (this.saving) {
      return;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.form.value.new_password !== this.form.value.confirm_new_password) {
      this.form.get('confirm_new_password')!.setErrors({ notMatch: true });
      this.form.get('confirm_new_password')!.markAsTouched();
      return;
    }

    this.saving = true;
    this.userService
      .changePassword(
        this.form.get('old_password')?.value,
        this.form.get('new_password')?.value
      )
      .subscribe({
        next: () => {
          this.saving = false;
          this.isEditing = false;
          this.form.reset();
        },
        error: () => {
          this.saving = false;
        },
      });
  }

  cancelEdit() {
    this.isEditing = false;
    this.form.reset();
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }
}
